import { OrderItemWithDetailDto } from "../../models/dto/orderItemWithDetailDto";
import { OrderEntity } from "../entity/order/order.entity";

export class OrderWithItemsDto {
  order: OrderEntity;
  orderItems: OrderItemWithDetailDto[];
  campaignName?: string;
  salesEmployeeName?: string;
  billingNo?: string;
}
